import { SVGProps } from 'react';

const Cog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 10.27 7 3.34m4 10.39-4 6.93M12 22v-2m0 0a8 8 0 1 0 0-16m0 16a8 8 0 0 1-8-8m8-10v2m0 0a8 8 0 0 0-8 8m10 0h8m-8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m3 8.66-1-1.73m1-15.59-1 1.73M2 12h2m16.66 5-1.73-1m1.73-9-1.73 1M3.34 17l1.73-1M3.34 7l1.73 1"
    />
  </svg>
);
export default Cog;
